// extracted by mini-css-extract-plugin
export var grid = "_2k-0";
export var span1 = "_2k-2";
export var span10 = "_2k-b";
export var span10L = "_2k-z";
export var span10M = "_2k-n";
export var span10Xl = "_2k-1b";
export var span11 = "_2k-c";
export var span11L = "_2k-10";
export var span11M = "_2k-o";
export var span11Xl = "_2k-1c";
export var span12 = "_2k-d";
export var span12L = "_2k-11";
export var span12M = "_2k-p";
export var span12Xl = "_2k-1d";
export var span1L = "_2k-q";
export var span1M = "_2k-e";
export var span1Xl = "_2k-12";
export var span2 = "_2k-3";
export var span2L = "_2k-r";
export var span2M = "_2k-f";
export var span2Xl = "_2k-13";
export var span3 = "_2k-4";
export var span3L = "_2k-s";
export var span3M = "_2k-g";
export var span3Xl = "_2k-14";
export var span4 = "_2k-5";
export var span4L = "_2k-t";
export var span4M = "_2k-h";
export var span4Xl = "_2k-15";
export var span5 = "_2k-6";
export var span5L = "_2k-u";
export var span5M = "_2k-i";
export var span5Xl = "_2k-16";
export var span6 = "_2k-7";
export var span6L = "_2k-v";
export var span6M = "_2k-j";
export var span6Xl = "_2k-17";
export var span7 = "_2k-8";
export var span7L = "_2k-w";
export var span7M = "_2k-k";
export var span7Xl = "_2k-18";
export var span8 = "_2k-9";
export var span8L = "_2k-x";
export var span8M = "_2k-l";
export var span8Xl = "_2k-19";
export var span9 = "_2k-a";
export var span9L = "_2k-y";
export var span9M = "_2k-m";
export var span9Xl = "_2k-1a";
export var stretch = "_2k-1";